import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import { clearPatchUser } from 'redux/settings/actions';
import {
  fetchSignupGenerator,
  clearSignupGenerator,
  clearSignupGeneratorStatus,
  clearUpdateSignupGeneratorStatus,
} from 'redux/signup-generator/actions';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import SignupGeneratorSwitcher
  from 'components/dashboard/signup-generator-content/SignupGeneratorSwitcher';
import SignupGeneratorAppearence
  from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence';
import SignupGeneratorColorsSelector
  from 'components/dashboard/signup-generator-content/SignupGeneratorColorsSelector';
import SignupGeneratorTerms
  from 'components/dashboard/signup-generator-content/SignupGeneratorTerms';
import SignupSubscribersList
  from 'components/dashboard/signup-generator-content/SignupSubscribersList';

import './SignupGeneratorPageContent.css';

class SignupGeneratorPageContent extends Component {
  static propTypes = {
    me: PropTypes.object,
    signupGenerator: PropTypes.object,
    createSignupGeneratorSuccess: PropTypes.object,
    updateSignupGeneratorSuccess: PropTypes.object,
    deleteSignupGeneratorSuccess: PropTypes.bool,
    fetchMe: PropTypes.func,
    fetchSignupGenerator: PropTypes.func,
    clearPatchUser: PropTypes.func,
    clearSignupGeneratorStatus: PropTypes.func,
    clearUpdateSignupGeneratorStatus: PropTypes.func,
  };
  static defaultProps = {
    me: null,
    signupGenerator: null,
    createSignupGeneratorSuccess: null,
    updateSignupGeneratorSuccess: null,
    deleteSignupGeneratorSuccess: null,
    fetchMe: null,
    fetchSignupGenerator: null,
    clearPatchUser: null,
    clearSignupGeneratorStatus: null,
    clearUpdateSignupGeneratorStatus: null,
  };

  componentDidMount() {
    if (this.props.me && this.props.me.signup_generator && !this.props.signupGenerator) {
      this.props.fetchSignupGenerator(this.props.me.signup_generator);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.createSignupGeneratorSuccess &&
      prevProps.createSignupGeneratorSuccess !== this.props.createSignupGeneratorSuccess) ||
      (!prevProps.deleteSignupGeneratorSuccess &&
      prevProps.deleteSignupGeneratorSuccess !== this.props.deleteSignupGeneratorSuccess)
    ) {
      this.props.fetchMe();
      setTimeout(() => {
        this.props.clearPatchUser();
        this.props.clearSignupGeneratorStatus();
      }, 500);
    }
    if (
      (!prevProps.me.signup_generator &&
      prevProps.me.signup_generator !== this.props.me.signup_generator) ||
      (!prevProps.updateSignupGeneratorSuccess &&
      prevProps.updateSignupGeneratorSuccess !== this.props.updateSignupGeneratorSuccess)
    ) {
      this.props.fetchSignupGenerator(this.props.me.signup_generator);
      setTimeout(() => {
        this.props.clearUpdateSignupGeneratorStatus();
      }, 500);
    }
  }

  render() {
    const { me, signupGenerator } = this.props;
    return (
      <div className="email-signup-generator-page-content__component">
        <DashboardFormSection>
          <SignupGeneratorSwitcher />

          {me && signupGenerator &&
            <>
              <SignupGeneratorAppearence />
              <SignupGeneratorTerms />
              <SignupGeneratorColorsSelector />
            </>
          }
        </DashboardFormSection>
        <SignupSubscribersList />
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    createSignupGeneratorSuccess: state.emailSignupGenerator.createSignupGeneratorSuccess,
    createSignupGeneratorError: state.emailSignupGenerator.createSignupGeneratorError,
    deleteSignupGeneratorSuccess: state.emailSignupGenerator.deleteSignupGeneratorSuccess,
    deleteSignupGeneratorError: state.emailSignupGenerator.deleteSignupGeneratorError,
    signupGenerator: state.emailSignupGenerator.signupGenerator,
    signupGeneratorError: state.emailSignupGenerator.signupGeneratorError,
    updateSignupGeneratorSuccess: state.emailSignupGenerator.updateSignupGeneratorSuccess,
    updateSignupGeneratorError: state.emailSignupGenerator.updateSignupGeneratorError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    clearPatchUser,
    fetchSignupGenerator,
    clearSignupGenerator,
    clearSignupGeneratorStatus,
    clearUpdateSignupGeneratorStatus,
  },
)(SignupGeneratorPageContent);
